import { closeDialog } from './dialogActions'

export function confirmPartnerConsent(userId, nextAction) {
  return function(dispatch) {
    dispatch(closeDialog('partnerConsent'))

    dispatch(nextAction(userId))
  }
}
